import { TrimEditableImageManager } from '../../editable-image/trim.editable-image.manager';
import { TrimFrameController } from '../frame/trim.frame-controller';
import { initPictureFlags, TrimImageController } from './trim.image-controller';
import * as lodash from 'lodash';
import { cloneDeep } from 'lodash';
import { TrimUiManager } from '../../ui/trim.ui.manager';
import { TrimImageEvent } from './trim.image-event';
import { TrimCjContainer } from '../../../model/cj-factory';
import { TrimDataManager } from '../../data/trim-data.manager';
import { TrimCjTool } from '../../../../utilities/trim.cj-tool';
import createjs from 'createjs-module';
import { TrimEditableEvent } from '../trim.editable-event';
import {
  CJ_BGIMAGE_NAME,
  CJ_CONTAINER_NAME,
  CJ_DPOBJ_NAME,
} from '../../../model/cj-factory/trim.cj-obj-name.collection';
import { FitChecker } from '../../../../utilities/fit-checker';
import { FocusModeType } from '../../data/trim-data-type';
import { TrimImageEditManager } from '../trim.image-edit.manager';
import { TrimPrintManager } from '../../../print/trim.print';
import { TrimTextEvent } from '../text/trim.text-event';

export type ListenerIdsType = {
  moveStart?: Function,
  moving?: Function,
  moveEnd?: Function,
}

type RemoveOption = {
  isUndo?: boolean;
}

type RepairOption = {
  isCopy?: boolean;
}

export class TrimImageEditableTool {
  private stage: TrimCjContainer;
  private readonly pageId: string;

  private editableImageManager!: TrimEditableImageManager;
  private frameController!: TrimFrameController;
  private imageController!: TrimImageController;
  private imageEvent!: TrimImageEvent;
  private trimDataManager!: TrimDataManager;
  private editableEvent!: TrimEditableEvent;
  private imageEditManager!: TrimImageEditManager;
  private textEvent!: TrimTextEvent;
  private printManager!: TrimPrintManager;
  rotateCount = 0;

  private ListenerIds: ListenerIdsType = {
    moveStart: undefined,
    moving: undefined,
    moveEnd: undefined,
  };

  constructor(stage: TrimCjContainer, pageId: string) {
    this.stage = stage;
    this.pageId = pageId;
  }

  di(
    imageController: TrimImageController,
    frameController: TrimFrameController,
    editableMng: TrimEditableImageManager,
    imageEvent: TrimImageEvent,
    layoutDataManager: TrimDataManager,
    editableEvent: TrimEditableEvent,
    imageEditMng: TrimImageEditManager,
    textEvent: TrimTextEvent,
    printMng: TrimPrintManager,
  ): void {
    this.imageController = imageController;
    this.frameController = frameController;
    this.editableImageManager = editableMng;
    this.imageEvent = imageEvent;
    this.trimDataManager = layoutDataManager;
    this.editableEvent = editableEvent;
    this.imageEditManager = imageEditMng;
    this.textEvent = textEvent;
    this.printManager = printMng;
  }

  initialize(): void {
  }

  destroy(): void {
  }

  update(stage: TrimCjContainer): void {
    this.stage = stage;
  }

  // - 写真枠モード -
  frameMode(image: TrimCjContainer) {
    // CjTool.getDummyFrame(image).alpha = 0;
    const focusMode = this.trimDataManager.getFocusMode();
    const target = TrimCjTool.getImageAreaContainer(image);
    this.removeEvt(target);
    this.editableEvent.disFocused(target);
    this.imageEvent.handleFocus(target, 'scale');
  }

  // - 写真編集モード -
  imageMode(image: TrimCjContainer, isPng?: boolean, isDai?: boolean) {
    if (isPng) {
      // this.editableEvent.disFocused(image);
      this.imageEvent.handlePngFocus(image);
      this.trimDataManager.setFocusMode('png')
      this.ListenerIds.moveStart = image.on('mousedown', (e: any) => {
        this.imageEvent.handleMoveStart(image, e, true);
      });
      this.ListenerIds.moving = image.on('pressmove', (e: any) => {
        this.imageEvent.handleMove(image, e, true);
      });
      this.ListenerIds.moveEnd = image.on('pressup', (e: any) => {
        this.imageEvent.handleMoveEnd(image, e, true);
      });
      this.imageEvent.imageInitData.push({
        target: image,
        param: {
          x: image.x,
          y: image.y,
          movePos: cloneDeep(image.movePos),
          rotation: image.rotation,
          scaleX: image.scaleX,
          scaleY: image.scaleY,
          regX: image.regX,
          regY: image.regY,
        },
      });
      return;
    }
    const photoContainer = TrimCjTool.getPhotoContainer(image);
    const target = TrimCjTool.getImageContainer(image);
    this.removeEvt(target);
    if (this.textEvent.isFocus && this.textEvent.targetFrame) {
      this.editableEvent.disFocused(this.textEvent.targetFrame);
    } else {
      this.editableEvent.disFocused(target);
    }
    target.mouseEnabled = true;
    isDai ? this.imageEvent.handleFocus(target, 'dai')
      : this.imageEvent.handleFocus(target, 'rotate');

    this.ListenerIds.moveStart = target.on('mousedown', (e: any) => {
      this.imageEvent.handleMoveStart(target, e);
    });
    this.ListenerIds.moving = target.on('pressmove', (e: any) => {
      this.imageEvent.handleMove(target, e);
    });
    this.ListenerIds.moveEnd = target.on('click', (e: any) => {
      e.stopPropagation();
      this.imageEvent.handleMoveEnd(target, e);
    });

    target.filters = [];
    target.uncache();
    photoContainer.alpha = 0.7;
    TrimCjTool.getDummyFrame(target).alpha = 0.2;
    this.imageEvent.imageInitData.push({
      target: target,
      param: {
        x: photoContainer.x,
        y: photoContainer.y,
        movePos: cloneDeep(photoContainer.movePos),
        rotation: photoContainer.rotation,
        scaleX: photoContainer.scaleX,
        scaleY: photoContainer.scaleY,
        regX: photoContainer.regX,
        regY: photoContainer.regY,
      },
    });
    this.imageEvent.updateToolPos(isPng ? 'png' : 'rotate', image);
  }

  // - 回転 -
  async rotate(v: number, target?: TrimCjContainer, isMargin?: boolean, isUndo?: boolean) {
    if (!target) return;
    const focusMode = this.trimDataManager.getFocusMode();
    if (focusMode === 'png') {
      const preAngle = target.rotation ?? 0;
      const angle = preAngle + v;
      target.rotation = angle >= 360 ? angle - 360 : angle;
      return;
    }
    const container = TrimCjTool.getRotateContainer(target);
    const isCheckPhoto = TrimCjTool.checkPhotoInFrame(container);
    const imageContainer = TrimCjTool.getImageContainer(container);
    const imageAreaContainer = TrimCjTool.getImageAreaContainer(container);
    const mask = TrimCjTool.getMaskContainer(target);
    const maskData = mask.getBounds();
    if (focusMode === 'rotate' || focusMode === 'dai') {
      const photo = TrimCjTool.getPhotoContainer(imageContainer);
      const image = TrimCjTool.getPhoto(imageContainer);
      if (v < 90) {
        if (isMargin) {
          const angle = isUndo ? -v : v;
          const _rotate = FitChecker.findClosestValidRotation(photo, photo.rotation, photo.rotation + angle);
            photo.rotation = _rotate;
        } else {
          photo.rotation += v;
        }
        // this.layoutDataManager.dispatch('setRotation', photo);
        // const photoFrames: [] = this.layoutDataManager.selector('getEditors', target.pageId);
        const isToast = FitChecker.checkImageOneOutBounds(target);
        this.imageEditManager.isFit = isToast;
        TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
        return;
      }
      let angle;
      let maskH;
      let maskW;
      switch (photo.rotation) {
        case 90:
          angle = 180;
          maskH = maskData.height;
          maskW = maskData.width;
          break;
        case 180:
          angle = 270;
          maskH = maskData.width;
          maskW = maskData.height;
          break;
        case 270:
          angle = 0;
          maskH = maskData.height;
          maskW = maskData.width;
          break;
        default:
          angle = 90;
          maskH = maskData.width;
          maskW = maskData.height;
          break;
      }
      // this.layoutDataManager.dispatch('setRotation', photo);
      const scale = await this.imageController.resizeImage(imageAreaContainer, image, maskH, maskW);
      photo.rotation = angle >= 360 ? angle - 360 : angle;
      photo.x = photo.defaultPos.x;
      photo.y = photo.defaultPos.y;
      photo.movePos = { x: 0, y: 0 };
      photo.scaleX = scale;
      photo.scaleY = scale;
    } else {
      container.isRotate = !container.isRotate;
      const angle = container.isRotate ? Number(container.rotation) + 90 : Number(container.rotation) - 90;
      container.rotation = angle;
      if (isCheckPhoto) {
        const photoContainer = TrimCjTool.getPhotoContainer(imageContainer);
        // const photo = CjTool.getPhoto(imageContainer);
        const _mask = TrimCjTool.getMaskContainer(target);
        const mask = _mask.getChildByName('mask').clone();
        mask.set({ alpha: 0, x: 0, y: 0 });
        // // -- 境界情報を取得 --
        const frame = TrimCjTool.getScaleContainer(target);
        const maskData = _mask.getTransformedBounds();
        imageContainer.filters = [];
        imageContainer.uncache();
        // photoContainer.rotation = container.isRotate ? photoContainer.rotation - 90 : photoContainer.rotation + 90;
        // mask.rotation = angle === 0 ? mask.rotation + 90 : mask.rotation - 90;
        // this.layoutDataManager.dispatch('setRotation', container);
        _mask.alpha = 0;
        mask.cache(0, 0, maskData.width, maskData.height);
        imageContainer.filters = [new createjs.AlphaMaskFilter(mask.cacheCanvas as HTMLCanvasElement)];
        imageContainer.cache(0, 0, maskData.width, maskData.height);
        // this.layoutDataManager.dispatch('setRotation', photoContainer);
        const editableList = this.editableImageManager.list;
        const photo = editableList.find((v) => v.id === photoContainer.editableImageId);
        await this.imageController.createPhotoImage(photo!, target);
        // this.imageController.resizeImage(photoContainer, photo, maskData.height, maskData.width);
        // this.imageController.centeringImage()
      }
      // this.layoutDataManager.dispatch('setRotation', container);
    }
    // const a = CjTool.getPhotoContainer(target).getTransformedBounds()
    // const b = CjTool.getImageAreaContainer(target).getTransformedBounds()
    // const test = new TrimCjShape();
    // test.graphics.s('red').dr(a.x + b.x, a.y + b.y,CjTool.getPhotoContainer(target).getTransformedBounds().width,CjTool.getPhotoContainer(target).getTransformedBounds().height);
    // this.stage.addChild(test)
    this.imageEvent.updateToolPos(focusMode, target);
    const isToast = FitChecker.checkImageOneOutBounds(target);
    this.imageEditManager.isFit = isToast;
    TrimUiManager.ins.emit('t->r:show-toast', { isToast, target });
  }

  // - イベントの削除 -
  removeEvt(target: TrimCjContainer, _type?: string) {
    const type = _type ? _type : this.trimDataManager.getFocusMode();
    switch (type) {
      case 'scale':
        break;
      case 'rotate':
      case 'dai':
        const container = TrimCjTool.getRotateContainer(target);
        // -- マスクを作成 --
        const _mask = TrimCjTool.getMaskContainer(target);
        const mask = _mask.getChildByName('mask').clone();
        mask.set({ alpha: 0, x: 0, y: 0 });
        // -- 境界情報を取得 --
        const frame = TrimCjTool.getScaleContainer(target);
        const maskData = _mask.getBounds();
        const imageContainer = TrimCjTool.getImageContainer(target);
        const photoContainer = TrimCjTool.getPhotoContainer(target);
        photoContainer.alpha = 1;
        TrimCjTool.getDummyFrame(target).alpha = 0;
        _mask.alpha = 0;
        if (!TrimCjTool.getImageAreaContainer(target)?.logoFlag) {
          mask.cache(0, 0, maskData.width, maskData.height);
          this.stage.getChildByName(CJ_BGIMAGE_NAME.overwrap);
          imageContainer.filters = [new createjs.AlphaMaskFilter(mask.cacheCanvas as HTMLCanvasElement)];
          imageContainer.cache(0, 0, maskData.width, maskData.height);
        }
        const imageArea = TrimCjTool.getImageAreaContainer(target);
        const containerLength = container.numChildren;
        imageArea && container.setChildIndex(imageArea, containerLength - 1);
        target.off('mousedown', this.ListenerIds.moveStart!);
        target.off('pressmove', this.ListenerIds.moving!);
        target.off('pressup', this.ListenerIds.moveEnd!);
        break;
      case 'move':
        this.stage.getChildByName(CJ_BGIMAGE_NAME.grayout).visible = false;
        // target.off('mousedown', this.ListenerIds.moveStart);
        // target.off('pressmove', this.ListenerIds.moving);
        // target.off('pressup', this.ListenerIds.moveEnd);
        break;
      case 'png':
        target.off('mousedown', this.ListenerIds.moveStart!);
        target.off('pressmove', this.ListenerIds.moving!);
        target.off('pressup', this.ListenerIds.moveEnd!);
        break;
      case 'none':
        break;
      default:
        break;
    }
  }

  // - 移動 -
  move() {
    if (!this.imageEvent.targetFrame) return;
    const target = TrimCjTool.getDefaultContainer(this.imageEvent.targetFrame);
    if (!target) return;
    const grayOut = this.stage.getChildByName(CJ_BGIMAGE_NAME.grayout);
    grayOut.visible = true;
    const frameLength = this.stage.numChildren;
    grayOut && this.stage.setChildIndex(grayOut, frameLength - 1);
    this.editableEvent.disFocused(target);
    this.imageEvent.handleFocus(target, 'move');
    TrimUiManager.ins.emit('t->r:dis-select');
  }

  // - 複製 -
  // clone(): TrimCjContainer | undefined {
  //   if (!this.stage || !this.imageEvent.targetFrame || !this.imageEvent.activeFocus) return;
  //   // -- セレクトの解除 --
  //   TrimUiManager.ins.emit('t->r:dis-select');
  //   const target = this.imageEvent.targetFrame;
  //   const container = TrimCjTool.getDefaultContainer(target);
  //   this.editableEvent.disFocused(target);
  //   const imageAreas = this.layoutDataManager.selector('getAllImageAreas', this.pageId);
  //   const maxIma = Math.max(...imageAreas.map((v: TrimCjContainer) => v.subMaskID));
  //   // -- クローン作成 --
  //   const clone = lodash.cloneDeep(container);
  //   const movePos = TrimCjTool.getImageAreaContainer(clone).movePos;
  //   // -- 新しいphotoAreaIdを発行（連番） --
  //   clone.photoAreaId = String(maxIma + 1);
  //   // -- 座標をすこしずらす --
  //   clone.x += 30;
  //   clone.y += 30;
  //   movePos.x += 30;
  //   movePos.y += 30;
  //
  //   TrimCjTool.getImageAreaContainer(clone).copyFlag = true;
  //   TrimCjTool.getImageAreaContainer(clone).orgsubMaskID = TrimCjTool.getImageAreaContainer(container).orgsubMaskID;
  //   TrimCjTool.getImageAreaContainer(clone).subMaskID = String(maxIma + 1);
  //   // CjTool.getImageAreaContainer(clone).subMaskID = String(Number(clone.frameId) + 1);
  //   // CjTool.getImageAreaContainer(clone).photoSeqNo = Number(clone.frameId) + 1;
  //   // -- イベント更新 --
  //   clone.removeAllEventListeners();
  //   const focusContainers = TrimCjTool.getFocusContainers(clone);
  //   for (const focusContainer of focusContainers) {
  //     focusContainer.parent.removeChild(focusContainer);
  //   }
  //   this.imageEvent.setImageEvent(clone, 'frame');
  //   // -- stageへ追加 --
  //   this.stage.addChild(clone);
  //   TrimCjTool.updateClonePram(clone);
  //   const cloneIma = TrimCjTool.getImageAreaContainer(clone);
  //   cloneIma.depth = imageAreas.length + 1;
  //   const editorContainers = this.layoutDataManager.selector('getAlbum')?.filter((v: any) => v?.pageId === this.pageId) ?? [];
  //   const maxFrame = Math.max(...editorContainers.map((v: TrimCjContainer) => v.frameId));
  //   clone.frameId = String(maxFrame + 1);
  //   const cloneScale = TrimCjTool.getScaleContainer(clone);
  //   this.layoutDataManager.dispatch('setEditorContainer', clone);
  //   this.layoutDataManager.dispatch('setImageAreaContainer', cloneIma);
  //   this.layoutDataManager.dispatch('setScaleContainer', cloneScale);
  //   TrimCjTool.getHighlight(target).visible = false;
  //   if (TrimCjTool.checkPhotoInFrame(clone)) {
  //     const image = TrimCjTool.getPhotoContainer(clone);
  //     const editableImage = cloneDeep(this.editableImageManager.list.find((elm) => elm.id === image.editableImageId));
  //     if (editableImage) {
  //       image.selectID = editableImage.selectId;
  //       image.subMaskID = String(maxIma + 1);
  //       editableImage.photoAreaId = clone.photoAreaId ?? '';
  //       this.imageController.createPhotoImage(editableImage, clone);
  //     }
  //   }
  //   return clone;
  // }

  // - ゴミ箱 -
  remove(target: TrimCjContainer, focusMode: FocusModeType, albumMng?: TrimPrintManager, option: RemoveOption = {}) {
    const frameLength = this.stage.numChildren;
    this.removeEvt(target, focusMode);
    if (focusMode === 'png') {
      target.deleteFlag = true;
      this.imageEvent.activeFocus && (this.imageEvent.activeFocus.visible = false);
      this.imageEvent.activeFocus = null;
      this.imageEvent.targetFrame = null;
      this.stage.removeChild(target);
      this.trimDataManager.removeFreeGraphic(target.editableImageId ?? '');
    } else {
      const editor = TrimCjTool.getDefaultContainer(target);
      const ima = TrimCjTool.getImageAreaContainer(target);

      const frameLength = this.stage.numChildren;
      // if (focusMode === 'dai') {
      //   this.layoutDataManager.selector('getAdditional', this.pageId).getChildByName(CJ_CONTAINER_NAME.mask).visible = true;
      //   CjTool.getMaskContainer(target).alpha = 1;
      // }
      const container = TrimCjTool.getRotateContainer(target);
      this.imageEvent.activeFocus && (this.imageEvent.activeFocus.visible = false);
      this.imageEvent.activeFocus = null;
      this.imageEvent.isFocus = false;
      this.imageEvent.targetFrame = null;
      container.removeChild(target);
      target.deleteFlag = true;
      TrimCjTool.getMaskContainer(container).alpha = 1;
      TrimUiManager.ins.emit('t->r:change-use-image-num', { type: 'decrement' });
      editor && this.stage.setChildIndex(editor, ima.depth || frameLength - 3);
    }
    TrimUiManager.ins.emit('t->r:dis-select');
    // this.editableEvent.disFocused(target);
  }

  // - 復活 -
  repairer(img: TrimCjContainer, focusMode: FocusModeType, parent?: TrimCjContainer, albumMng?: TrimPrintManager, option: RepairOption = {}) {
    if (!this.stage) return;
    if (focusMode === 'png') {
      (img.getChildByName(CJ_DPOBJ_NAME.freeGraphic) as TrimCjContainer).deleteFlag = false;
      this.editableImageManager.toUse(img.editableImageId ?? '');
      this.stage.addChild(img);
      this.trimDataManager.setFreeGraphic(img);
    } else if (focusMode === 'rotate' || focusMode === 'dai') {
      (img.getChildByName(CJ_CONTAINER_NAME.photo) as TrimCjContainer).deleteFlag = false;
      img.deleteFlag = false;
      this.editableImageManager.toUse(img.editableImageId ?? '');
      parent && parent.addChild(img);
      this.imageMode(img, false, focusMode === 'dai');
      if (img.editableImageId) {
        albumMng?.currentPrint?.editableIDList.push(img.editableImageId);
      }
    } else {
      if (img.name === CJ_CONTAINER_NAME.editor) {
        const frame = TrimCjTool.getDefaultContainer(img!);
        TrimCjTool.getImageAreaContainer(img).deleteFlag = false;
      }
      if (TrimCjTool.checkPhotoInFrame(img)) {
        TrimCjTool.getPhotoContainer(img).deleteFlag = false;
        TrimCjTool.getImageContainer(img).deleteFlag = false;
        const image = TrimCjTool.getImageContainer(img);
        this.editableImageManager.toUse(image.editableImageId ?? '');
        if (image.editableImageId) {
          albumMng?.currentPrint?.editableIDList.push(image.editableImageId);
        }

        // this.layoutDataManager.dispatch('setImageContainer', image);
      }
      // img.name === CJ_CONTAINER_NAME.image
      TrimUiManager.ins.emit('t->r:change-use-image-num', { type: 'increment' });
      this.stage.addChild(img);
      if (img.name === CJ_CONTAINER_NAME.editor) {
        const frame = TrimCjTool.getDefaultContainer(img!);
        const imageArea = TrimCjTool.getImageAreaContainer(frame);
        const frameLength = this.stage.numChildren;
        if (imageArea) {
          this.stage.setChildIndex(frame, imageArea.depth ?? frameLength - 3);
        }
      }
    }
  }

  async reLayoutImage() {
    if (!this.printManager.editableImage) {
      throw new Error('editableImage not found !!!!!!!!!');
    }
    const editorContainer = this.trimDataManager.getEditor();
    const imageContainer = this.trimDataManager.getImage();
    this.remove(imageContainer, 'rotate');
    await this.imageController.createPhotoImage(this.printManager.editableImage, editorContainer, true);
    this.editableEvent.sortContainer();
  }

}
